module.exports = __webpack_public_path__ + "img/louane.f5130532.jpg";